/* istanbul ignore file */
import React from 'react';

interface CheckIconProps {
    style?: React.CSSProperties;
}

export const CheckIcon = ({ style }: CheckIconProps) => {
    return (
        <svg
            style={style}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.6663 5L7.49967 14.1667L3.33301 10"
                stroke="#089855"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
